import React from 'react';

import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

import { IExerciseProperty } from '../../../../types/interfaces/exercise-property';
import AppEntityAvatar, {
  AppEntityAvatarProps,
} from '../app-entity-avatar/AppEntityAvatar';

interface AppExercisePropertyAvatarProps extends AppEntityAvatarProps {
  exerciseProperty?: IExerciseProperty;
}

export default function AppExercisePropertyAvatar(
  props: AppExercisePropertyAvatarProps,
) {
  const { exerciseProperty, ...avatarProps } = props;

  return (
    <AppEntityAvatar
      {...avatarProps}
      fallbackSeedId={exerciseProperty?.id}
      fallbackSeedName={exerciseProperty?.name}
      directPreviewStorageLink={
        exerciseProperty?.avatar?.directPreviewStorageLink
      }
      directStorageLink={exerciseProperty?.avatar?.directStorageLink}
      previewStorageLink={exerciseProperty?.avatar?.previewStorageLink}
      storageLink={exerciseProperty?.avatar?.storageLink}>
      <FormatListBulletedIcon />
    </AppEntityAvatar>
  );
}
